class Config {
      public static get baseUrl() : string  {
           // return "https://decoapi.framemytv.com";
           return process.env.REACT_APP_BASE_URL!;
        }

}

export default Config;